import { render } from "./IntegrationsList.vue?vue&type=template&id=16649270"
import script from "./IntegrationsList.vue?vue&type=script&lang=js"
export * from "./IntegrationsList.vue?vue&type=script&lang=js"

import "./IntegrationsList.vue?vue&type=style&index=0&id=16649270&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__